import React from 'react';
import PropTypes from 'prop-types';
import {
  LuBriefcaseBusiness,
  LuCalendarDays,
  LuFolderOpen,
  LuIdCard,
  LuMessagesSquare,
  LuTreePalm,
  LuWallet,
} from 'react-icons/lu';
import { useTranslation } from '../../../../../i18n/LanguageContext';
import { abs } from '../../engine/stage';
import { NAV_GROUPS, navRects } from '../../layout';
import { GLASS_PANEL } from '../kit';

const ICONS = {
  'takvim-ajanda': LuCalendarDays,
  dosyalar: LuFolderOpen,
  projelerim: LuBriefcaseBusiness,
  'izin-yonetimi': LuTreePalm,
  'masraf-yonetimi': LuWallet,
  'iletisim-bildirim': LuMessagesSquare,
  'cv-yonetimi': LuIdCard,
};

/**
 * The profile section nav: a row of group pills (the active one a teal
 * gradient) and, for groups with several parts, a second row of sub-tabs.
 * badges: { dosyalar: 3, 'iletisim-bildirim': 2, mesajlar: 2 }
 */
const ProfileNav = ({ top, group, tab, badges = {}, hover }) => {
  const { t } = useTranslation();
  const rects = navRects(top, group);
  const active = NAV_GROUPS.find((item) => item.key === group);
  return (
    <div className="tw-absolute tw-inset-0 tw-z-[5]">
      <div style={abs(rects.panel)} className={`tw-absolute tw-rounded-[1.5rem] ${GLASS_PANEL}`} />
      {active?.tabs && <span style={{ left: 268, top: top + 50, width: 976 }} className="tw-absolute tw-h-px tw-bg-slate-200/80 dark:tw-bg-white/10" />}
      {NAV_GROUPS.map((item) => {
        const Icon = ICONS[item.key];
        const selected = item.key === group;
        const badge = badges[item.key];
        return (
          <span
            key={item.key}
            style={abs(rects.pills[item.key])}
            className={`tw-absolute tw-flex tw-items-center tw-justify-center tw-gap-2 tw-rounded-full tw-px-3 tw-text-[14px] tw-font-semibold tw-transition-colors tw-duration-300 ${
              selected ? 'tw-bg-gradient-to-r tw-from-teal-500 tw-to-cyan-600 tw-text-white tw-shadow-md tw-shadow-teal-500/30' : hover === item.key ? 'tw-bg-slate-900/[0.05] tw-text-slate-900 dark:tw-bg-white/[0.07] dark:tw-text-white' : 'tw-text-slate-700 dark:tw-text-slate-300'
            }`}
          >
            <Icon aria-hidden="true" className="tw-h-4 tw-w-4 tw-shrink-0" />
            <span className="tw-truncate">{t(`profilePage.nav.groups.${item.key}`)}</span>
            {badge ? (
              <span className={`tw-grid tw-h-5 tw-min-w-[1.25rem] tw-place-items-center tw-rounded-full tw-px-1 tw-text-[10px] tw-font-bold ${selected ? 'tw-bg-white tw-text-teal-700' : 'tw-bg-rose-500 tw-text-white'}`}>{badge}</span>
            ) : null}
          </span>
        );
      })}
      {active?.tabs && active.tabs.map(([key]) => {
        const selected = key === tab;
        const badge = badges[key];
        return (
          <span
            key={key}
            style={abs(rects.tabs[key])}
            className={`tw-absolute tw-flex tw-items-center tw-justify-center tw-gap-1.5 tw-rounded-full tw-px-2 tw-text-[13px] tw-font-semibold tw-transition-colors tw-duration-300 ${selected ? 'tw-bg-teal-500/10 tw-text-teal-800 dark:tw-text-teal-200' : 'tw-text-slate-600 dark:tw-text-slate-400'}`}
          >
            <span className="tw-truncate">{t(`profilePage.nav.tabs.${key}`)}</span>
            {badge ? <span className="tw-grid tw-h-4 tw-min-w-[1rem] tw-place-items-center tw-rounded-full tw-bg-rose-500 tw-px-1 tw-text-[10px] tw-font-bold tw-text-white">{badge}</span> : null}
          </span>
        );
      })}
    </div>
  );
};

ProfileNav.propTypes = { top: PropTypes.number.isRequired, group: PropTypes.string.isRequired, tab: PropTypes.string.isRequired, badges: PropTypes.object, hover: PropTypes.string };

export default ProfileNav;
